var arslunaLightcase = function($) {
    "use strict";
    function resizeThumbs(selector) {
        var transitionTime = $(selector).data('transition_time');
        if (!isNumber(transitionTime)) {
            transitionTime = 500;
        }
        $(selector + " .image").each(function(){
            var width,
                height,
                image,
                opacity,
                el = $(this);
            width = Math.floor($(this).parent().width());
            el.css("height",width + "px");
            image = el.data("wallpaper");
            el.css("background-image","url(" + image + ")");
            el.css("background-size","cover");
            el.css("background-position","center center");
            el.css("background-repeat","no-repeat");
            opacity = el.css("opacity");
            if (isNumber(opacity) && opacity < 1) {
                el.animate({opacity: 1}, transitionTime);
            }
        });
        $(selector + " .showcase").matchHeight();

    }
    return {
        resizeThumbs : resizeThumbs
    };
}
(jQuery); // END arslunaLightcase
